import { themeAtom } from "../../../shared/atoms";
import { AdminBqTqFormGridRow } from "../../models/admin-bq-tq-forms.models";
import { ArrowPathIcon, PencilSquareIcon } from "@heroicons/react/24/outline";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

interface Props {
  formCountLabel: string;
  selectedRow: AdminBqTqFormGridRow | null;
  isRefreshing: boolean;
  onOpenSelected: () => void;
  onRefresh: () => void;
}

const AdminBqTqFormsTopBar = ({ formCountLabel, selectedRow, isRefreshing, onOpenSelected, onRefresh }: Props) => {
  const theme = useAtomValue(themeAtom);

  return (
    <header
      data-test="admin-bq-tq-forms-top-bar"
      className="relative z-50 flex h-11 flex-none items-center border-b border-gray-200 bg-white px-3 dark:border-gray-700 dark:bg-gray-800"
    >
      <div className="flex min-w-0 flex-1 items-center gap-2 overflow-hidden pr-3">
        <h1 className={twMerge("min-w-0 truncate text-sm font-semibold leading-5", theme.home.tailwind.textDefault)}>
          BQ/TQ Form Admin
        </h1>
        <span
          className="hidden flex-none border border-[#D7E2DE] px-2 py-1 text-[11px] font-semibold text-[#4A5655] md:inline-flex"
          data-test="admin-bq-tq-forms-count"
        >
          {formCountLabel}
        </span>
      </div>
      <div className="ml-3 flex h-full flex-none items-center gap-2 bg-white pl-2 dark:bg-gray-800">
        <button
          type="button"
          aria-label="Refresh forms"
          title="Refresh"
          data-test="admin-bq-tq-forms-refresh"
          disabled={isRefreshing}
          onClick={onRefresh}
          className="inline-flex h-8 w-8 items-center justify-center border border-gray-300 text-green transition-colors hover:bg-[#E9F4F3] disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700"
        >
          <ArrowPathIcon className={twMerge("h-4 w-4", isRefreshing && "animate-spin")} />
        </button>
        <button
          type="button"
          data-test="admin-bq-tq-forms-open-selected"
          disabled={!selectedRow}
          onClick={onOpenSelected}
          className="inline-flex h-8 min-w-8 items-center justify-center gap-1.5 bg-green px-2 text-xs font-semibold text-white transition-colors hover:bg-[#166b60] disabled:cursor-not-allowed disabled:opacity-40 2xl:px-3"
        >
          <PencilSquareIcon className="h-4 w-4" />
          <span className="hidden xl:inline">Open Form</span>
        </button>
      </div>
    </header>
  );
};

export default AdminBqTqFormsTopBar;
